import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import Footer from "../SharePages/Footer/Footer";
import Navbar from "../SharePages/Navbar/Navbar";
import SideNavBar from "../SharePages/SideNavBar/SideNavBar";
import { fareChangeQuotation } from "../../common/allApi";
import TableLoader from "../../component/tableLoader";
import NoDataFound from "../../component/noDataFound";
import { MdOutlineSkipPrevious } from "react-icons/md";
import { MdOutlineSkipNext } from "react-icons/md";
import { ToastContainer } from "react-toastify";
import { FaEye } from "react-icons/fa";

const FareChangeQuotation = () => {
  let [pageCount, setPageCount] = useState(0);
  let [pageSize, setPageSize] = useState(10);
  let [currentPageNumber, setCurrentPageNumber] = useState(1);
  let [quotationList, setQuotationList] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const [isTimeOut, setIsTimeOut] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsTimeOut(true), 10000);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const now = new Date();
  const [sendObj, setSendObj] = useState({
    fromDate: moment(new Date(now.getFullYear(), now.getMonth(), 1)).format(
      "YYYY-MM-DD"
    ),
    toDate: moment(now).format("YYYY-MM-DD"),
    uniqueTransId: "",
    pnr: "",
    status: "",
    agentId: sessionStorage.getItem("agentId"),
  });

  const [filterData, setfilterData] = useState({
    fromDate: moment(new Date(now.getFullYear(), now.getMonth(), 1)).format(
      "YYYY-MM-DD"
    ),
    toDate: moment(now).format("YYYY-MM-DD"),
    uniqueTransId: "",
    pnr: "",
    status: "",
  });
  useEffect(() => {
    const getFareChangeQuotation = async () => {
      try {
        setLoading(true);
        const response = await fareChangeQuotation({
          ...filterData,
          pageSize: pageSize,
          pageNumber: currentPageNumber,
        });
        setQuotationList(await response?.data?.data?.data);
        setPageCount(await response?.data?.data?.totalPages);
        setLoading(false);
      } catch {
        setLoading(false);
      }
    };
    getFareChangeQuotation();
  }, [isSearch, currentPageNumber, pageSize, filterData]);

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setCurrentPageNumber(currentPage);
  };

  const handleClear = () => {
    setCurrentPageNumber(1);
    setSendObj({
      uniqueTransId: "",
      fromDate: moment(new Date(now.getFullYear(), now.getMonth(), 1)).format(
        "YYYY-MM-DD"
      ),
      toDate: moment(now).format("YYYY-MM-DD"),
      agentId: sessionStorage.getItem("agentId"),
      pnr: "",
      status: "",
    });
    setfilterData({
      fromDate: moment(new Date(now.getFullYear(), now.getMonth(), 1)).format(
        "YYYY-MM-DD"
      ),
      toDate: moment(now).format("YYYY-MM-DD"),
      uniqueTransId: "",
      pnr: "",
      status: "",
    });
  };

  const handleViewQuotation = (id) => {
    window.open(`/fare-quotation-view?id=${id}`, "_blank");
  };
  const [idxD, setIdxD] = useState("SotoTicket");
  let onStatusChange = (statusId) => {
    setIdxD(statusId);
  };
  return (
    <div>
      <Navbar></Navbar>
      <SideNavBar></SideNavBar>
      <div className="content-wrapper search-panel-bg px-4 pb-5">
        <section className="content-header"></section>
        <section className="content">
          <ToastContainer position="bottom-right" autoClose={1500} />
          <form className="mx-lg-5 mx-md-5 mx-sm-1 mt-3">
            <div className="container-fluid bg-white">
              <div className="row">
                <div
                  className="col-lg-12 border-bottom d-flex justify-content-start p-0 ms-2 ms-lg-0"
                  style={{
                    whiteSpace: "nowrap",
                    overflowX: "auto",
                    scrollbarWidth: "none", // For Firefox
                    WebkitOverflowScrolling: "touch", // For smooth scrolling on iOS
                    msOverflowStyle: "none", // For IE and Edge
                  }}
                >
                  <div
                    className={
                      idxD === "SotoTicket"
                        ? "custom-selected-tab px-3 rounded-top fs-6 py-3 fw-bold"
                        : "fs-6 px-3 py-3 fw-bold text-black"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => onStatusChange("SotoTicket")}
                  >
                    <span
                      className={
                        idxD === "SotoTicket" &&
                        "custom-border-selected-tab pb-3"
                      }
                    >
                      Fare Change Quotation
                    </span>
                  </div>
                </div>
              </div>

              <div className="row p-2 py-3">
                <div className="container-fluid bg-white">
                  <div className="row my-3">
                    <div className="col-sm-2 mb-3 mb-lg-0">
                      <select
                        value={sendObj?.status}
                        className="form-select border-radius"
                        placeholder="Upcoming Day"
                        onChange={(e) =>
                          setSendObj({
                            ...sendObj,
                            status: e.target.value,
                          })
                        }
                      >
                        <option value="">Select Status</option>
                        <option value="Quoted">Quoted</option>
                        <option value="Expired">Expired</option>
                        <option value="Rejected">Rejected</option>
                        <option value="Accepted">Accepted</option>
                        <option value="Completed">Completed</option>
                      </select>
                    </div>
                    <div className="col-sm-2 mb-3 mb-lg-0">
                      <input
                        type={"text"}
                        value={sendObj?.uniqueTransId}
                        onChange={(e) =>
                          setSendObj({
                            ...sendObj,
                            uniqueTransId: e.target.value,
                          })
                        }
                        className="form-control border-radius"
                        placeholder="Booking ID"
                      ></input>
                    </div>
                    <div className="col-sm-2 mb-3 mb-lg-0">
                      <input
                        type={"text"}
                        value={sendObj?.pnr}
                        onChange={(e) =>
                          setSendObj({
                            ...sendObj,
                            pnr: e.target.value,
                          })
                        }
                        className="form-control border-radius"
                        placeholder="GDS PNR"
                      ></input>
                    </div>

                    <div className="col-sm-2 mb-3 mb-lg-0">
                      <input
                        type={"date"}
                        pattern="\d{4}-\d{2}-\d{2}"
                        max={new Date().toISOString().split("T")[0]}
                        value={sendObj?.fromDate}
                        onChange={(e) =>
                          setSendObj({
                            ...sendObj,
                            fromDate: e.target.value,
                          })
                        }
                        className="form-control border-radius"
                        placeholder="From Date"
                      ></input>
                    </div>
                    <div className="col-sm-2 mb-3 mb-lg-0">
                      <input
                        type={"date"}
                        pattern="\d{4}-\d{2}-\d{2}"
                        max={new Date().toISOString().split("T")[0]}
                        value={sendObj?.toDate}
                        onChange={(e) =>
                          setSendObj({
                            ...sendObj,
                            toDate: e.target.value,
                          })
                        }
                        className="form-control border-radius"
                        placeholder="To Date"
                      ></input>
                    </div>

                    <div className="col-lg-2">
                      <div className="col-sm-12">
                        <button
                          type="button"
                          class="btn button-color fw-bold text-white border-radius filter-btn"
                          onClick={() => {
                            setIsSearch((old) => !old);
                            setCurrentPageNumber(1);
                            setfilterData(sendObj);
                          }}
                        >
                          Apply Filter
                        </button>
                        <button
                          type="button"
                          style={{ backgroundColor: "#ED7F22" }}
                          class="btn  fw-bold text-white border-radius ms-2 filter-btn"
                          onClick={() => handleClear()}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="table-responsive">
                  <table
                    className="table  table-lg"
                    style={{ width: "100%", fontSize: "13px" }}
                  >
                    <thead className="text-start fw-bold bg-secondary">
                      <tr>
                        <th>BOOKING ID</th>
                        <th>PNR</th>
                        <th>ROUTE</th>
                        <th>AIRLINE</th>
                        <th>FLIGHT DATE</th>
                        <th>QUOTATION DATE</th>
                        <th className="text-end">TOTAL PRICE</th>
                        <th>TOTAL PASSENGER</th>
                        <th>REJECTION DATE</th>
                        <th>STATUS</th>
                        <th>ACTION</th>
                      </tr>
                    </thead>
                    <tbody className="tbody">
                      {isLoading ? (
                        <tr>
                          <td colSpan="11" style={{ textAlign: "center" }}>
                            <TableLoader />
                          </td>
                        </tr>
                      ) : quotationList.length > 0 ? (
                        quotationList.map((item, index) => {
                          return (
                            <tr
                              key={index}
                              className="text-start fw-bold text-secondary"
                            >
                              <td
                                style={{
                                  color: "#068b9f",
                                  fontWeight: 800,
                                }}
                              >
                                <a
                                  href="javascript:void(0)"
                                  //   onClick={() =>
                                  //     handleViewTicket(
                                  //       item.uniqueTransId,
                                  //       item.status
                                  //     )
                                  //   }
                                >
                                  {item.uniqueTransId}
                                </a>
                              </td>
                              <td
                                style={{
                                  color: "#068b9f",
                                  fontWeight: 800,
                                }}
                              >
                                <a
                                  href="javascript:void(0)"
                                  //   onClick={() =>
                                  //     handleViewTicket(
                                  //       item.bookingId,
                                  //       item.status
                                  //     )
                                  //   }
                                >
                                  {item.pnr}
                                </a>
                              </td>
                              <td>{item?.routes ?? ""}</td>
                              <td>{item?.platingCarrier}</td>

                              <td>
                                {item.flightDate != null ? (
                                  moment(item.flightDate).format(
                                    "DD-MM-YYYY HH:mm"
                                  )
                                ) : (
                                  <></>
                                )}
                              </td>
                              <td>
                                {moment(item.createdDate).format(
                                  "DD-MM-YYYY HH:mm"
                                )}
                              </td>
                              <td className="text-end text-dark">
                                BDT {item?.totalPrice?.toLocaleString("en-US")}
                              </td>
                              <td>{item.totalPassengerCount}</td>
                              <td>
                                {item.rejectionDate != null ? (
                                  moment(item.rejectionDate).format(
                                    "DD-MMM-YYYY"
                                  )
                                ) : (
                                  <>N/A</>
                                )}
                              </td>

                              <td>
                                <div className="mb-2">
                                  {item.status === "Quoted" ||
                                  item.status === "Accepted" ||
                                  item.status === "Completed" ? (
                                    <span className="px-3 py-2 rounded active-status-color ">
                                      {item.status}
                                    </span>
                                  ) : (
                                    <span className="px-3 py-2 rounded inactive-status-color">
                                      {item.status}
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td className="text-center">
                                <>
                                  <a
                                        href="javascript:void(0)"
                                        title="View Quotation"
                                        onClick={() =>
                                          handleViewQuotation(item.id)
                                        }
                                      >
                                        <FaEye
                                          className="shadow p-1 rounded-3 text-white button-color"
                                          style={{ fontSize: "25px" }}
                                        />
                                      </a>
                                </>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </tbody>
                  </table>

                  {quotationList?.length === 0 && !isLoading && <NoDataFound />}
                </div>

                <div className="d-flex justify-content-end">
                  {quotationList?.length > 0 && !isLoading && (
                    <ReactPaginate
                      previousLabel={
                        <div className="d-flex align-items-center gap-1">
                          <MdOutlineSkipPrevious
                            style={{ fontSize: "18px" }}
                            color="#ed8226"
                          />{" "}
                          Prev
                        </div>
                      }
                      nextLabel={
                        <div className="d-flex align-items-center gap-1">
                          <MdOutlineSkipNext
                            style={{ fontSize: "18px" }}
                            color="#ed8226"
                          />
                          Next
                        </div>
                      }
                      breakLabel={"..."}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      forcePage={currentPageNumber - 1}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={
                        "pagination justify-content-center py-2 border rounded"
                      }
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  )}
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default FareChangeQuotation;
